import type { Locale, Translations } from '@/intl/types';

// Remove this const with OPTIMIZE_TRANSLATION_IMPORT FF
export const translations: Record<string, Record<string, string>> = {
  'fr-BE': require('./translations/fr-BE'),
  'nl-BE': require('./translations/nl-BE'),
  'da-DK': require('./translations/da-DK'),
  'de-DE': require('./translations/de-DE'),
  'en-GB': require('./translations/en-GB'),
  'fr-FR': require('./translations/fr-FR'),
  'nl-NL': require('./translations/nl-NL'),
  'sv-SE': require('./translations/sv-SE'),
};

type TranslationImport = () => Promise<{ default: Translations }>;

const translationsImportByLanguageMap: Record<string, TranslationImport> = {
  'fr-BE': () => import('./translations/fr-BE.json'),
  'nl-BE': () => import('./translations/nl-BE.json'),
  'nl-NL': () => import('./translations/nl-NL.json'),
  'sv-SE': () => import('./translations/sv-SE.json'),
  'da-DK': () => import('./translations/da-DK.json'),
  'de-DE': () => import('./translations/de-DE.json'),
  'en-GB': () => import('./translations/en-GB.json'),
  'fr-FR': () => import('./translations/fr-FR.json'),
};

export function createTranslationRepository({ map = translationsImportByLanguageMap }) {
  async function getFor(locale: Locale) {
    const importTranslations = map[locale];

    if (importTranslations == null) {
      console.warn(`Requested locale ${locale} is not available, falling back to nl-NL`);
      return (await import('./translations/nl-NL.json')).default;
    }

    const importedTranslations = await importTranslations();

    return importedTranslations.default;
  }

  return { getFor };
}

export default createTranslationRepository({ map: translationsImportByLanguageMap });
